import { applicationLocalStorage } from '@application/application_storage_local';
import { UnitService } from '@application/unit.service';
import { UniversalConfig } from '@application/universal_config.service';
import { Injectable, Scopes } from '@visiba/instantiation';

export interface CreateNewMessageSettings {
	predefinedDescriptionOfMatter: string | null;
	predefinedReasonForVisit: number[] | null;
	redRobinSessionId: string | null;
	asAgentFor: string | null;
	attachFiles: boolean;
}

@Injectable({
	scope: Scopes.Scoped,
})
export class CreateNewMessageSettingsService {
	private receptionId: number;

	constructor(
		private readonly universalConfig: UniversalConfig,
		private readonly unitService: UnitService,
	) {
		const unit = this.unitService.getUnitNodeInTree(this.universalConfig.selectedUnitId);
		this.receptionId = unit.receptionId;
	}

	public getSettings(): CreateNewMessageSettings {
		const settings = applicationLocalStorage.get('createNewMessageSettings') ?? {};

		return (
			settings[this.receptionId] ?? {
				predefinedDescriptionOfMatter: null,
				predefinedReasonForVisit: null,
				redRobinSessionId: null,
				asAgentFor: null,
				attachFiles: true,
			}
		);
	}

	public setSettings(flowSettings: Partial<CreateNewMessageSettings>): void {
		const settings = applicationLocalStorage.get('createNewMessageSettings') ?? {};

		settings[this.receptionId] = {
			...this.getSettings(),
			...flowSettings,
		};

		applicationLocalStorage.set('createNewMessageSettings', settings);
	}

	public clearSettings(): void {
		const settings = applicationLocalStorage.get('createNewMessageSettings') ?? {};

		delete settings[this.receptionId];

		applicationLocalStorage.set('createNewMessageSettings', settings);
	}
}
